import { apiFetch } from "./http";
// Musteri (firma + logo) API istemcisi — DOCX kapak sayfasi icin.
const API_BASE = "/api/v1/customers";

export type Customer = {
  id: string;
  name: string;
  logo_data_url?: string;
  created_at: string;
  updated_at: string;
};

export type CustomerListResponse = {
  count: number;
  customers: Customer[];
};

export async function listCustomers(): Promise<CustomerListResponse> {
  const res = await apiFetch(`${API_BASE}/`);
  if (!res.ok) throw new Error(`listCustomers: HTTP ${res.status}`);
  return res.json();
}

export async function getCustomer(id: string): Promise<Customer> {
  const res = await apiFetch(`${API_BASE}/${id}`);
  if (!res.ok) throw new Error(`getCustomer: HTTP ${res.status}`);
  return res.json();
}

export async function createCustomer(name: string, logoFile?: File | null): Promise<Customer> {
  if (logoFile) {
    const fd = new FormData();
    fd.append("name", name);
    fd.append("logo", logoFile);
    const res = await apiFetch(`${API_BASE}/`, { method: "POST", body: fd });
    if (!res.ok) {
      const body = await res.text();
      throw new Error(`createCustomer: HTTP ${res.status} — ${body}`);
    }
    return res.json();
  }
  const res = await apiFetch(`${API_BASE}/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) throw new Error(`createCustomer: HTTP ${res.status}`);
  return res.json();
}

export async function updateCustomer(id: string, patch: { name?: string; logoFile?: File | null }): Promise<Customer> {
  if (patch.logoFile) {
    const fd = new FormData();
    if (patch.name) fd.append("name", patch.name);
    fd.append("logo", patch.logoFile);
    const res = await apiFetch(`${API_BASE}/${id}`, { method: "PUT", body: fd });
    if (!res.ok) throw new Error(`updateCustomer: HTTP ${res.status}`);
    return res.json();
  }
  const res = await apiFetch(`${API_BASE}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: patch.name ?? "" }),
  });
  if (!res.ok) throw new Error(`updateCustomer: HTTP ${res.status}`);
  return res.json();
}

export async function deleteCustomer(id: string): Promise<void> {
  const res = await apiFetch(`${API_BASE}/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 404) throw new Error(`deleteCustomer: HTTP ${res.status}`);
}
